import { FlowOfFundsSubTab } from '../../../enums/flow-of-funds-sub-tab.enum';
import { NotificationFlagsCategories } from '../../../models/NotificationFlags/NotificationFlagsCategories';

interface FlowOfFundsTabDescriptor {
    id: FlowOfFundsSubTab;
    content: string;
    /** Appended to `MP.<engagementId>.FLOW_OF_FUNDS.` to build the sub-tab's flag code. */
    notificationFlagCode?: string;
}

export const FlowOfFundsTabs: FlowOfFundsTabDescriptor[] = [
    {
        id: FlowOfFundsSubTab.OverallDealStructure,
        content: 'Purchase Price Consideration',
    },
    {
        id: FlowOfFundsSubTab.ThirdPartyPayoffs,
        content: '3rd Party Payoffs',
    },
    {
        id: FlowOfFundsSubTab.VetValueFees,
        content: 'VetValue Fees',
    },
    {
        id: FlowOfFundsSubTab.LegalFees,
        content: 'Legal Fees',
        notificationFlagCode: NotificationFlagsCategories.LegalFeesCode,
    },
    {
        id: FlowOfFundsSubTab.WireTransferSummary,
        content: 'Wire Transfer Summary',
    },
];
